import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '../material/material.module';

import { BreadcrumbComponent } from './_components/breadcrumb/breadcrumb.component';
import { ButtonComponent } from './_components/button/button.component';
import { CardComponent } from './_components/card/card.component';
import { ConfirmDialogComponent } from './_components/confirm-dialog/confirm-dialog.component';
import { FilterChipComponent } from './_components/filter-chip/filter-chip.component';
import { GlobalHeaderComponent } from './_components/global-header/global-header.component';
import { GuidelinesDialogComponent } from './_components/guidelines-dialog/guidelines-dialog.component';
import { HeaderComponent } from './_components/header/header.component';
import { InputComponent } from './_components/input/input.component';
import { MultiSelectComponent } from './_components/multi-select/multi-select.component';
import { NeedHelpCardComponent } from './_components/need-help-card/need-help-card.component';
import { PageHeaderComponent } from './_components/page-header/page-header.component';
import { PaginationComponent } from './_components/pagination/pagination.component';
import { SelectComponent } from './_components/select/select.component';
import { SideMenuComponent } from './_components/side-menu/side-menu.component';
import { SnackbarComponent } from './_components/snackbar/snackbar.component';
import { TableComponent } from './_components/table/table.component';
import { YesNoToggleComponent } from './_components/yes-no-toggle/yes-no-toggle.component';

const EXPORTED_COMPONENTS = [
    BreadcrumbComponent,
    ButtonComponent,
    CardComponent,
    ConfirmDialogComponent,
    FilterChipComponent,
    GlobalHeaderComponent,
    GuidelinesDialogComponent,
    HeaderComponent,
    InputComponent,
    MultiSelectComponent,
    NeedHelpCardComponent,
    PageHeaderComponent,
    PaginationComponent,
    SelectComponent,
    SideMenuComponent,
    SnackbarComponent,
    TableComponent,
    YesNoToggleComponent,
];

const EXPORTED_MODULES = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    TranslateModule,
    MaterialModule,
];

@NgModule({
    declarations: [...EXPORTED_COMPONENTS],
    imports: [...EXPORTED_MODULES],
    exports: [...EXPORTED_COMPONENTS, ...EXPORTED_MODULES],
})
export class SharedModule {}
